import { Button, Input, Stack, Wrap } from '@chakra-ui/react';
import * as React from 'react';

import { DataPhTags } from '@/analytics';
import { useSignUpPrompt } from '@/hooks/useSignUpPrompt';
import { Card } from '@/imports/ui/chakra/components/Card';
import { CurrentUserAvatar } from '@/imports/ui/chakra/components/CurrentUserAvatar';
import { Semibold } from '@/imports/ui/chakra/components/Semibold';

type IFeedTriggerProps = {
  onClickQuestion: () => void;
  onClickPost: () => void;
  onClickArticle: () => void;
  onClickPoll: () => void;
};

export const FeedCTA: React.FC<IFeedTriggerProps> = (props) => {
  const { onClickPost, onClickArticle, onClickPoll, onClickQuestion } = props;
  const { promptModal, withPrompt, loading: promptLoading } = useSignUpPrompt();

  if (promptLoading) {
    return null;
  }

  return (
    <Card>
      {promptModal}
      <Stack direction="row" spacing="2" p="4">
        <CurrentUserAvatar boxSize={10} />
        <Input
          as="button"
          variant="filled"
          textAlign="left"
          onClick={withPrompt(onClickPost)}
          data-ph={DataPhTags.POST_CREATE}
          borderRadius="full"
        >
          Post a <Semibold>message</Semibold> to the community
        </Input>
      </Stack>
      <Wrap borderTop="1px" borderColor="gray.200" px="4" py="2" spacing="2">
        <Button
          colorScheme="gray"
          size="sm"
          variant="ghost"
          onClick={withPrompt(onClickQuestion)}
          data-ph={DataPhTags.QUESTION_ASK}
        >
          Ask a Question
        </Button>
        <Button
          colorScheme="gray"
          size="sm"
          variant="ghost"
          onClick={withPrompt(onClickArticle)}
          data-ph="article_create"
        >
          Write an Article
        </Button>
        <Button
          colorScheme="gray"
          size="sm"
          variant="ghost"
          onClick={withPrompt(onClickPoll)}
          data-ph="poll_create"
        >
          Create a Poll
        </Button>
      </Wrap>
    </Card>
  );
};
